// listen for changes in details, property search, attach summary objects to layers. 
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils.js";
import { createSummaryModal } from "../UI/summaryModal";
import { showSummaryModal } from "../UI/summaryModal";

let conditionalMapOptions; 
let WinGISMap; 

createSummaryModal(); 

export function setupParcelLink(parcelLink, pin, summaryType) {
    parcelLink.addEventListener("click", () => {
        doSummary(pin, summaryType); 
    })
}

function doSummary(pin, summaryType) {
    const summary = new summaryType(pin);
    showSummaryModal(summary);
    summary.displaySummary();
}

export default async function (winGISMap, ConditionalMapOptions) {
  WinGISMap = winGISMap; 
  conditionalMapOptions = ConditionalMapOptions; 








    let summaryActionListener = reactiveUtils.on(
    () => WinGISMap.view.popup,
    "trigger-action",
    (event) => {
        console.log(event); 
        if (event.action.id === "view-summary") {
            let pin = event.action.pin; 
            let summaryType = event.action.summaryType; 
            doSummary(pin, summaryType); 
        }
    }
    );

}

export async function doUrlSummaryCheck(conditionalMapOptions) {
    return new Promise( async (resolve, reject) => {
        let rtsPin = new URLSearchParams(window.location.search);
        const newParams = new URLSearchParams(
        Array.from(rtsPin, ([key, value]) => [key.toLowerCase(), value])
        );
    
        if (newParams.has("summary"))
        {
            let type = (await import("../Summaries/summaryObjects/Implementation/" + conditionalMapOptions.summaryType)).default; 
            doSummary(newParams.get("summary"), type); 
            resolve(true); 
        }
        else {
            resolve(false); 
        }
    
    
    })
}